import moment from "moment-timezone"
import { Employee, Expense, RolesEnum, Workflow } from "@finway-group/shared/lib/models"
import { GetEmployeeById } from "@finway-group/shared/lib/models/user/employee.model"
import { getAllRemainingApprovers } from "../workflows/workflow.utils"
import { FINWAY_ADMIN_EMAIL } from "Shared/config/consts"
import { ExpensePaymentOptionEnum } from "@finway-group/shared/lib/models/expense/expensePaymentOption.enum"

export const getEmployeesByIdsInAbsenceOfLeave = (employeeIds: any, employees: Employee[]) => {
    return employees.filter((employee: Employee) => {
        if (!employeeIds.includes(employee.id)) return false
        return employee.isInAbsenceOfLeave()
    })
}

export const getAbsentApprovers = (expense: Expense, workflows: Workflow[], employees: Employee[]) => {
    const approvers = expense.workflow ? getAllRemainingApprovers(workflows, expense) : [expense.approvalNeededBy]
    const absentApprovers = getEmployeesByIdsInAbsenceOfLeave(approvers, employees)

    return absentApprovers
}

/*Admin is considered absent if it is currently or in the next in absence of leave */
export const isAdminAbsent = (startDate: Date, endDate: Date, timeZone: string = "Europe/Berlin") => moment.tz(timeZone).isBetween(startDate, endDate, "day", "[]") || moment.tz(startDate, timeZone).isBetween(moment(), moment().add(1, "week"), "day", "[]")

export const getAvailableReplacementsForAbsentApprover = (expense: Expense, employees: Employee[]) => {
    const requestedBy = GetEmployeeById(employees, expense.requestedBy)

    const availableReplacementsForAbsentApprover = employees.filter(({ activeCompanyProfile: { role }, id, email, companyProfiles, absence, timeZone }) => {
        if (email === FINWAY_ADMIN_EMAIL || id === requestedBy?.id || role !== RolesEnum.ADMIN) return false
        if (expense?.paymentOption === ExpensePaymentOptionEnum.SMART_CARD) {
            const isEnrolledInACardProgram = companyProfiles?.find((profile) => profile.weavrData?.userId)
            if (!isEnrolledInACardProgram) return false
        }

        return !absence || !isAdminAbsent(absence.startDate, absence.endDate, timeZone)
    })

    return availableReplacementsForAbsentApprover
}

export const formatEmployeeAbsenceDate = (employee: Employee) =>
    `${moment.tz(employee.absence?.startDate, employee.timeZone).format("Do MMM, YYYY")} - ${moment.tz(employee.absence?.endDate, employee.timeZone).format("Do MMM, YYYY")}`
